/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationLabelKind =
  (typeof GroupByConversationLabelKind)[keyof typeof GroupByConversationLabelKind];

export const GroupByConversationLabelKind = {
  conversation_label: 'conversation_label',
} as const;
